import { noop } from "lodash"; // eslint-disable-next-line import/no-anonymous-default-export

export default {
  //NOTE: DO NOT SET DEFAULTS HERE FOR PROPS THAT GET COMPUTED AS PART OF PRESET GROUPS IN computePresets
  addFilters: noop,
  className: "",
  clearFilters: noop,
  contextMenu: noop,
  disabled: false,
  entities: [],
  extraClasses: "",
  filters: [],
  isCopyable: true,
  isEntityDisabled: noop,
  isLoading: false,
  isSimple: false,
  isSingleSelect: false,
  maxHeight: 600,
  noHeader: false,
  noSelect: false,
  noUserSelect: false,
  onDeselect: noop,
  onMultiRowSelect: noop,
  onRowClick: noop,
  onRowSelect: noop,
  onSingleRowSelect: noop,
  page: 1,
  pageSize: 10,
  reduxFormExpandedEntityIdMap: {},
  reduxFormSearchInput: "",
  reduxFormSelectedEntityIdMap: {},
  removeSingleFilter: noop,
  resized: [],
  resizePersist: noop,
  setFilter: noop,
  setOrder: noop,
  setPage: noop,
  setPageSize: noop,
  setSearchTerm: noop,
  showCount: false,
  style: {},
  withCheckboxes: false,
  withSort: true
};